"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    relatedGames: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: theme.spacing(2)
    },
    relatedGameTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginTop: theme.spacing(2)
    },
    relatedGameMedia: {
        height: 250,
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
            height: 204.5
        },
        [theme.breakpoints.down('md')]: {
            height: 305
        },
        [theme.breakpoints.down('xs')]: {
            height: 314
        }
    }
});
exports.default = styles;
//# sourceMappingURL=EligibleGamesStyle.js.map